import React, {useEffect, useMemo, useState} from 'react'
import PageLayout from '../../components/layout/PageLayout'
import useQueryUserList from '../../hooks/api/user/useQueryUserList'
import {IUserList} from '../../apis/user/getUserList'
import UserSearchContainer from '../../features/page/user/UserSearchContainer'
import UserListTable from '../../features/page/user/UserListTable'
import {useNavigate, useSearchParams} from 'react-router-dom'
import WizPagination from '../../components/pagination/WizPagination'

interface IProps {
    className?: string
}

const UserListPage: React.FC<IProps> = ({className}) => {
    const [searchParams] = useSearchParams(document.location.search)
    const queryKeyword = searchParams.get('keyword')
    const navigate = useNavigate()
    const [searchKeyword, setSearchKeyword] = useState(queryKeyword || '')
    const [currentPage, setCurrentPage] = useState(1)
    const {data, refetch} = useQueryUserList(searchKeyword, currentPage)

    const userList = useMemo(() => {
        let list: IUserList[] = []
        data?.data?.map(item => list.push(item))
        return list
    }, [data])

    useEffect(() => {
        if (searchKeyword && queryKeyword !== searchKeyword) {
            navigate(`?keyword=${searchKeyword}`)
        }
        if (searchKeyword === '') {
            navigate('/')
        }
        refetch()
    }, [searchKeyword])

    useEffect(() => {
        refetch()
    }, [currentPage])

    return (
        <PageLayout title={'User'} className={className}>
            <UserSearchContainer search={searchKeyword} onClick={e => setSearchKeyword(e)} />
            <UserListTable data={userList} className={'mt-[30px]'} />
            <WizPagination
                totalPage={data?.pageInfo?.total_count}
                currentPage={currentPage}
                onPageChange={item => setCurrentPage(item)}
            />
        </PageLayout>
    )
}

export default UserListPage
